import { Map, Marker, NavigationControl } from "maplibre-gl"
import tonerMapStyle from "../data/toner-map-style.json"

const center = [24.73062, 59.452373]
// Roughly Estonia's bounding box, so panning can't leave the country
const maxBounds = [
  [21.5, 57.5],
  [28.2, 59.7],
]
const mapEls = document.querySelectorAll("[data-ft-map]")

mapEls.forEach((mapEl) => {
  const map = new Map({
    container: mapEl,
    style: tonerMapStyle,
    center,
    zoom: 16,
    minZoom: 8,
    maxZoom: 18,
    maxBounds,
  })

  map.addControl(new NavigationControl())

  const pin = document.createElement("div")
  pin.className = "ft-map-pin"
  pin.innerHTML =
    '<svg width="16" height="16" viewBox="0 0 16 16"><circle cx="8" cy="8" r="7" fill="red" /></svg>'

  new Marker({ element: pin }).setLngLat(center).addTo(map)
})
